/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_item = {
    readonly isAvailable: boolean | null;
    readonly isSold: boolean | null;
    readonly hasPrivateListing: boolean | null;
    readonly hasActiveHoldForBuyer?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailPayments_item" | "PdpSharedDetailReturnPolicy_item" | "PdpSharedDepositPaymentDetail_item" | "PdpSharedDetailShipping_item">;
    readonly " $refType": "PdpRespShippingReturns_item";
};
export type PdpRespShippingReturns_item$data = PdpRespShippingReturns_item;
export type PdpRespShippingReturns_item$key = {
    readonly " $data"?: PdpRespShippingReturns_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isAvailable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasPrivateListing",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDepositPaymentDetail_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasActiveHoldForBuyer",
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'a4ab31f0da4d648487b5e8f2b13805b9';
export default node;
